import videoFileService from 'services/videoFileService';

// Bloque C - Preferencias Musicales (carga lazy)
const blockC = [
  {
    id: 'C1',
    type: 'music_test',
    introText: 'A continuación, escucharás algunos fragmentos musicales anónimos de 20 segundos cada uno. Solo se reproducirá el audio (sin imagen) para mantener el anonimato. Tu tarea será indicar si te gusta o no cada uno de ellos. Cada fragmento podrá ser reproducido máximo 2 veces.',
    currentScreen: 'intro',
    songs: [
      {
        id: 'song1',
        name: 'No Diggity',
        videoUrl: '/video/fragments/fragment_1.mp4'
      },
      {
        id: 'song2',
        name: 'Lose Yourself',
        videoUrl: '/video/fragments/fragment_2.mp4'
      },
      {
        id: 'song3',
        name: 'My Sharona',
        videoUrl: '/video/fragments/fragment_3.mp4'
      },
      {
        id: 'song4',
        name: 'Titanium',
        videoUrl: '/video/fragments/fragment_4.mp4'
      }
    ],
    pairs: [
      {
        id: 'pair1',
        songA: 'song1',
        songB: 'song2'
      },
      {
        id: 'pair2',
        songA: 'song3',
        songB: 'song4'
      }
    ]
  }
];

// Función para cargar dinámicamente los videos desde el servicio
export const loadDynamicVideos = async () => {
  try {
    const videos = await videoFileService.getVideosForBlockC();
    blockC[0].songs = videos;
    
    // Regenerar pares automáticamente basado en los videos disponibles
    const pairs = [];
    for (let i = 0; i < videos.length - 1; i += 2) {
      if (videos[i + 1]) {
        pairs.push({
          id: `pair${Math.floor(i / 2) + 1}`,
          songA: videos[i].id,
          songB: videos[i + 1].id
        });
      }
    }
    blockC[0].pairs = pairs;
    
    return blockC[0];
  } catch (error) {
    return blockC[0]; // Fallback to static data
  }
};

export default blockC;